import { render } from "./DistrictManagement.vue?vue&type=template&id=9b352a00"
import script from "./DistrictManagement.vue?vue&type=script&lang=js"
export * from "./DistrictManagement.vue?vue&type=script&lang=js"

import "./DistrictManagement.vue?vue&type=style&index=0&id=9b352a00&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__